<template>
  <div>
    <Hero kind="empty" />

    <ProjectHero />

    <ProjectDescription
      :active-tab="activeTab"
      @click="setActiveTab"
    />

    <ProjectPagination @click="resetTab"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { FETCH_PROJECT_BY_SLUG } from 'store/actions';
import { GET_PROJECT } from 'store/getters';
import Hero from 'components/Hero';

const ProjectHero = () => import('components/ProjectHero');
const ProjectDescription = () => import('components/ProjectDescription');
const ProjectPagination = () => import('components/ProjectPagination');

export default {
  name: 'Projects',
  components: {
    ProjectDescription,
    Hero,
    ProjectHero,
    ProjectPagination,
  },
  props: {
    slug: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      activeTab: 'issue',
    };
  },
  computed: {
    ...mapGetters({
      project: GET_PROJECT,
    }),
  },
  watch: {
    $route() {
      this.fetchProject();
    },
  },
  created() {
    this.fetchProject();
  },
  methods: {
    ...mapActions([FETCH_PROJECT_BY_SLUG]),
    fetchProject() {
      this[FETCH_PROJECT_BY_SLUG](this.slug).catch(() => {});
    },
    setActiveTab(value) {
      this.activeTab = value;
    },
    resetTab() {
      this.activeTab = 'issue';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Project.vue